import PlanList from "../Views/Admin/PlanList.vue";
import PlanCreate from "../Views/Admin/PlanCreate.vue";
import PlanEdit from "../Views/Admin/PlanEdit.vue";
import { adminGuard } from "./guards.js";

export const planRoutes = [
    {
        path: "/admin/plans",
        name: "admin.plans.list",
        component: PlanList,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'admin-plans',
                child: null
            },
            breadcrumb: {
                title: "Gestion des abonnements",
                nav: {
                    all: {
                        active: "Tous les abonnements",
                        inactive: []
                    }
                }
            }
        },
    },
    {
        path: "/admin/plans/create",
        name: "admin.plans.create",
        component: PlanCreate,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'admin-plans',
                child: null
            },
            breadcrumb: {
                title: "Gestion des abonnements",
                nav: {
                    all: {
                        active: "Créer un abonnement",
                        inactive: [{
                            title: "Tous les abonnements",
                            link: {name: 'admin.plans.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/admin/plans/edit/:id",
        name: "admin.plans.edit",
        component: PlanEdit,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'admin-plans',
                child: null
            },
            breadcrumb: {
                title: "Gestion des abonnements",
                nav: {
                    all: {
                        active: "Modifier l'abonnement",
                        inactive: [{
                            title: "Tous les abonnements",
                            link: {name: 'admin.plans.list'}
                        }]
                    }
                }
            }
        },
    },
];
